export const getProtocol = () => (process.env.USE_SSL === "true" ? "https" : "http");
